import { render, staticRenderFns } from "./context.vue?vue&type=template&id=52041de8&scoped=true"
import script from "./context.vue?vue&type=script&lang=js"
export * from "./context.vue?vue&type=script&lang=js"
import style0 from "./context.vue?vue&type=style&index=0&id=52041de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52041de8",
  null
  
)

export default component.exports